import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';

export interface ProjectWindowState {
	punchListId: number;
}

@Injectable()
@StoreConfig({ name: 'project-window-store' })
export class ProjectWindowStore extends Store<ProjectWindowState> {
	constructor() {
		super({
			punchListId: null
		});
	}

	updatePunchListId(punchListId: number) {
		this.update({
			...this._value(),
			punchListId
		})
	}
}
